import usePageLocalStorageContext from "./usePageLocalStorageContext"

export default usePageLocalStorageContext
